export default class TwitterRequestToken {
  constructor(public token: string, public secret: string) {}
}
